/**
 * Categorías de Google Places, en cristiano.
 *
 * El backend guarda el CÓDIGO que devuelve la Places clásica (`bar`,
 * `hair_care`) y no una frase, por lo mismo que con los estados de lead: el
 * valor viaja por la API y la etiqueta la pone la interfaz. Así cambiar cómo se
 * lee una categoría no obliga a volver a pagarle a Google por la ficha.
 *
 * La tabla cubre lo que de verdad hay en el parque —hostelería, comercio y
 * servicios de barrio— y **no pretende ser el catálogo entero de Google**, que
 * son más de cien tipos. Lo que no esté cae a `prettyType`, que al menos deja
 * algo legible en pantalla en vez de un hueco.
 */

/** Código de Google → clave i18n. Solo los que se ven a menudo. */
export const PLACE_TYPE_LABELS = {
  restaurant: 'placeType.restaurant',
  bar: 'placeType.bar',
  cafe: 'placeType.cafe',
  bakery: 'placeType.bakery',
  meal_takeaway: 'placeType.mealTakeaway',
  meal_delivery: 'placeType.mealDelivery',
  night_club: 'placeType.nightClub',
  lodging: 'placeType.lodging',
  hair_care: 'placeType.hairCare',
  beauty_salon: 'placeType.beautySalon',
  spa: 'placeType.spa',
  gym: 'placeType.gym',
  dentist: 'placeType.dentist',
  doctor: 'placeType.doctor',
  physiotherapist: 'placeType.physiotherapist',
  veterinary_care: 'placeType.veterinaryCare',
  pharmacy: 'placeType.pharmacy',
  clothing_store: 'placeType.clothingStore',
  shoe_store: 'placeType.shoeStore',
  jewelry_store: 'placeType.jewelryStore',
  furniture_store: 'placeType.furnitureStore',
  hardware_store: 'placeType.hardwareStore',
  supermarket: 'placeType.supermarket',
  grocery_or_supermarket: 'placeType.supermarket',
  convenience_store: 'placeType.convenienceStore',
  florist: 'placeType.florist',
  book_store: 'placeType.bookStore',
  pet_store: 'placeType.petStore',
  car_repair: 'placeType.carRepair',
  car_dealer: 'placeType.carDealer',
  car_wash: 'placeType.carWash',
  gas_station: 'placeType.gasStation',
  real_estate_agency: 'placeType.realEstateAgency',
  insurance_agency: 'placeType.insuranceAgency',
  lawyer: 'placeType.lawyer',
  accounting: 'placeType.accounting',
  travel_agency: 'placeType.travelAgency',
  school: 'placeType.school',
  laundry: 'placeType.laundry',
  storage: 'placeType.storage',
  moving_company: 'placeType.movingCompany',
  electrician: 'placeType.electrician',
  plumber: 'placeType.plumber',
  painter: 'placeType.painter',
  locksmith: 'placeType.locksmith',
  tourist_attraction: 'placeType.touristAttraction',
};

/**
 * `hair_care` → `Hair care`. Último recurso para un tipo que no está en la
 * tabla: peor que una traducción, mucho mejor que una celda vacía.
 */
export function prettyType(value) {
  if (!value) return '';
  const words = String(value).replace(/_/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** La categoría tal y como se pinta. Cadena vacía si Google no mandó ninguna. */
export function placeTypeLabel(value, t) {
  if (!value) return '';
  const key = PLACE_TYPE_LABELS[value];
  return key ? t(key) : prettyType(value);
}
